
import { getFieldLabel } from "@/util/DataUtil";
export default {
  getHead: () => {
    return [{ name: getFieldLabel() }, { name: "활동날짜" }, { name: "활동의사" }, { name: "총상담인원" }, { name: "근골격상담인원" }, { name: "건강상담내용" }, { name: "작성자" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 사업장명
      case 1:
        return func.getContent(value).inputA_3; // 활동날짜
      case 2:
        return func.getContent(value).inputA_4; // 활동의사
      case 3:
        return func.comma(func.getContent(value).inputA_5); // 총상담인원
      case 4:
        return func.comma(func.getContent(value).inputA_6); // 근골격상담인원
      case 5:
        return func.getContent(value).inputA_7; // 건강상담내용
      case 6:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 7:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case getFieldLabel():
      return ["content$body.stdInfo.field_name*%[:default_skw]%"];
    case "활동날짜":
      return ["content$body.inputA_3*%[:default_skw]%"];
    case "활동의사":
      return ["content$body.inputA_4*%[:default_skw]%"];
    case "총상담인원":
      return ["content$body.inputA_5*%[:default_skw]%"];
    case "근골격상담인원":
      return ["content$body.inputA_6*%[:default_skw]%"];
    case "건강상담내용":
      return ["content$body.inputA_7*%[:default_skw]%"];
    case "작성자":
      return ["content$body.stdInfo.writer_name*%[:default_skw]%"];
    }
    return [];
  },
};
